import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import { fullGradientColors } from "@/components/AIComponents/AiComponents.style";

const { ui } = constants.colors;
const white = ui.white[500];

export const bodyCss: CSSObject = {
  background: ui.white[500],
  borderRadius: "0 0 0.6em 0.6em",
};

export const expanderContentCss: CSSObject = { overflow: "hidden" };

export const rootCss = (isTeacherToolsCollapsed = false): CSSObject => {
  return {
    border: "1px solid transparent",
    borderRadius: isTeacherToolsCollapsed ? "10px 10px 0 0" : "10px",
    width: "100%",
    maxWidth: "900px",
    marginBottom: "2em",
    zIndex: "0",
    background:
      `linear-gradient(${white}, ${white}) padding-box, ` +
      `linear-gradient(282deg, ${fullGradientColors.position100.color} 0%, ${fullGradientColors.position50.color} 52.24%, ${fullGradientColors.position25.color} 77.37%, ${fullGradientColors.position0.color} 102.51%) border-box`,
    backgroundClip: "padding-box, border-box",
  };
};
